// components/StatusChip.js
import React from "react";
import { Chip } from "@mui/material";
import { Icon } from "@iconify/react";

const statusStyles = {
  Pending: {
    label: "Pending",
    color: "warning",
    icon: "mdi:clock-outline",
  },
  Approved: {
    label: "Approved",
    color: "success",
    icon: "mdi:check-circle-outline",
  },
  Rejected: {
    label: "Rejected",
    color: "error",
    icon: "mdi:close-circle-outline",
  },
  Created: {
    label: "Created",
    color: "info",
    icon: "mdi:plus-circle-outline",
  },
  Modified: {
    label: "Modified",
    color: "primary",
    icon: "mdi:pencil-outline",
  },
  Deleted: {
    label: "Deleted",
    color: "error",
    icon: "mdi:delete-outline",
  },
  Cancelled: {
    label: "Cancelled",
    color: "default",
    icon: "mdi:cancel",
  },
};

const StatusChip = ({ status }) => {
  const style = statusStyles[status] || {
    label: status,
    color: "default",
    icon: "mdi:help-circle-outline",
  };

  return (
    <Chip
      icon={<Icon icon={style.icon} width={13} />}
      label={style.label}
      color={style.color}
      variant="outlined"
      size="small"
      sx={{ height: 15, fontSize: "0.6rem" }}
    />
  );
};

export default StatusChip;
